<script lang="ts" setup>
const props = defineProps<{
  url?: string
  title?: string
  description?: string
}>()

const networks = ref([
  {
    key: 'facebook',
    name: 'Facebook',
    icon: 'logos:facebook',
    class: 'w-10.5 h-10.5',
    url: 'https://www.facebook.com/sharer/sharer.php?u=',
  },
  {
    key: 'twitter',
    name: 'Twitter',
    icon: 'ri:twitter-x-fill',
    class: 'w-8 h-8',
    url: 'https://twitter.com/intent/tweet?url=',
  },
  {
    key: 'telegram',
    name: 'Telegram',
    icon: 'logos:telegram',
    class: 'w-10.5 h-10.5 text-[#2f6ea2]',
    url: 'https://t.me/share/url?url=',
  },
  {
    key: 'whatsapp',
    name: 'Whatsapp',
    icon: 'mdi:whatsapp',
    class: 'text-3xl',
    url: 'https://api.whatsapp.com/send?text=',
  },
])

const route = useRoute()

const {
  public: { siteUrl },
} = useRuntimeConfig()

const url = computed(() => props.url ?? siteUrl + route.fullPath)
</script>

<template>
  <section class="flex flex-row flex-wrap gap-3.5">
    <div class="flex flex-wrap justify-center items-center mx-auto gap-3.5">
      <template v-for="network in networks">
        <NuxtLink
          :to="
            network.key === 'facebook'
              ? network.url + url
              : network.url + title + '%0A%0A' + url
          "
          target="_blank"
          class="animated-hover overflow-hidden rounded-full flex items-center justify-center pl-2 pr-7.5 bg-black py-1.5 h-13.5 relative z-1"
        >
          <div class="flex flex-row items-center justify-center relative z-2">
            <div class="w-10.5 h-10.5 flex items-center justify-center">
              <Icon :name="network.icon" :class="network.class" />
            </div>
            <span class="text-base ml-4"> {{ network.name }}</span>
          </div>
        </NuxtLink>
      </template>
    </div>
  </section>
</template>

<style scoped>
@reference "tailwindcss";

.animated-hover::before {
  @apply -z-1 absolute top-1/2 left-1/2 w-0 h-0  content-[''] rounded-full;
  transform: translate(-50%, -50%);
  transition:
    width 0.5s ease-out,
    height 0.5s ease-out;
}

.animated-hover:nth-child(1):before {
  @apply bg-[#1877f2];
}

.animated-hover:nth-child(2):before {
  @apply bg-[#7540ee];
}

.animated-hover:nth-child(3):before {
  @apply bg-[#2bacee];
}
.animated-hover:nth-child(4):before {
  @apply bg-[#57f676];
}

.animated-hover:hover::before {
  @apply w-50 h-50;
}
</style>
